export const SUCCESS_TOASTS = {
  fileUploaded: { title: 'File uploaded successfully' },
  payoffDocumentUploaded: { title: 'Payoff document uploaded successfully' },
  passwordChanged: { title: 'Password changed successfully' },
  passwordSaved: {
    title: 'Password saved',
    description: 'Next time, sign in with your email and password. One-time links still work too.',
  },
  payoffFoundAutomatically: {
    title: 'Great news — we got your payoff automatically!',
    description: 'No action needed.',
  },
};
